export interface IdleOptions {
    duration?: number;
    idleOnEscapeKey?: boolean;
    idle?: boolean;
    onIdle?: () => void;
    onBusy?: () => void;
}

export type IdleState = "idle" | "busy";

export class Idle {

    public readonly onIdle = e5.Signal.create();
    public readonly onBusy = e5.Signal.create();
    public readonly onChange = e5.Signal.create<[{ state: IdleState }]>();

    private _duration: number;
    private _timeout: any = null;
    private _isIdle: boolean = true;

    constructor(options: IdleOptions) {

        options = e5.object.merge({
            idleOnEscapeKey: true,
            idle: true,
            duration: 5 * 60 * 1000
        }, options);
        this._duration = options.duration;

        this.setIdle = this.setIdle.bind(this);

        document.addEventListener("pointerdown", (e) => this.setBusy(),
            {
                capture: true,
                passive: true
            });
        document.addEventListener("keyup", (e) => {
            if (options.idleOnEscapeKey
                && e5.KeyCode.is(e, e5.KeyCode.ESCAPE)) {
                this.setIdle();
            } else {
                this.setBusy();
            }
        },
            {
                capture: true,
                passive: true
            });

        this.updateIdle(options.idle);

        if (typeof options.onIdle === "function") {
            this.onIdle.add(options.onIdle);
        }

        if (typeof options.onBusy === "function") {
            this.onBusy.add(options.onBusy);
        }
    }

    public get state(): IdleState {
        return this._isIdle ? "idle" : "busy";
    }

    public set state(state: IdleState) {
        if (state === "idle") {
            this.updateIdle(true);
        } else if (state === "busy") {
            this.updateIdle(false);
        }
    }

    public setIdle(force: boolean = false): void {
        if (force && this.state === "idle") {
            this.setBusy();
        }
        this.updateIdle(true);
    }

    public setBusy(force: boolean = false): void {
        if (force && this.state === "busy") {
            this.setIdle();
        }
        this.updateIdle(false);
    }

    private updateIdle(value: boolean) {
        if (!value) {
            if (this._timeout) {
                clearTimeout(this._timeout);
                this._timeout = null;
            }

            this._timeout = setTimeout(this.setIdle, this._duration);
        }

        if (this._isIdle === value) {
            return;
        }
        this._isIdle = value;
        if (this._isIdle) {
            this.onIdle.dispatch();
        } else {
            this.onBusy.dispatch();
        }

        this.onChange.dispatch({
            state: this.state
        });
    }
}